import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { DateInputComponent } from '../../form-components/date-input/date-input.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-member-table-date-input',
  templateUrl: '../../form-components/date-input/date-input.component.html',
  styleUrls: ['../member-table-input.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MemberTableDateInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.Default
})
export class MemberTableDateInputComponent extends DateInputComponent {}
